import { isCanonicalDateString } from '@unistocks/components/date-picker/hooks/use-dates-state/date-string-fast-path';
import { createDate } from '@unistocks/shared/utils/util';
import type { DateStringValue } from '../../types';

/**
 * Whether `date` is on or after `minDate` (no lower bound when `minDate` is
 * absent). Mirrors @mantine/dates `isAfterMinDate`.
 *
 * The lower-bound twin of `isBeforeMaxDate` — the dayjs spelling
 * (`isAfter(minDate - 1 day, "day")`) is a day-granularity `>=`, exactly a
 * lexicographic `>=` for canonical zero-padded `yyyy-MM-dd` strings. Same hot
 * path (once per cell in `Month`, again in `getDateInTabOrder`), same fallback
 * for non-canonical input.
 */
export function isAfterMinDate(
  date: DateStringValue,
  minDate: DateStringValue | undefined
): boolean {
  if (!minDate) {
    return true;
  }

  if (isCanonicalDateString(date) && isCanonicalDateString(minDate)) {
    return date.slice(0, 10) >= minDate.slice(0, 10);
  }

  return createDate(date).startOf('day') >= createDate(minDate).startOf('day');
}
